import Navigation from "@/components/Navigation";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Stethoscope, Sparkles, Timer, Shield } from "lucide-react";

const treatments = [
  {
    title: "Botox Treatment",
    description: "Reduce fine lines and wrinkles with precision neurotoxin treatments",
    details: "Our neurotoxin treatments target specific facial muscles to reduce the appearance of wrinkles and prevent new ones from forming. Treatment sessions typically take 15-30 minutes.",
    icon: Timer,
    duration: "15-30 minutes",
    results: "Results visible within 3-7 days",
    longevity: "3-4 months"
  },
  {
    title: "Dermal Fillers",
    description: "Restore volume and enhance facial contours",
    details: "Premium dermal fillers to restore lost volume, enhance facial contours, and achieve natural-looking results. We use only FDA-approved products.",
    icon: Sparkles,
    duration: "30-45 minutes",
    results: "Immediate results",
    longevity: "6-18 months"
  },
  {
    title: "Skin Tightening",
    description: "Advanced treatments for improved skin elasticity",
    details: "Non-invasive treatments using the latest technology to improve skin elasticity and firmness, stimulating natural collagen production.",
    icon: Shield,
    duration: "45-60 minutes",
    results: "Gradual improvement over 2-3 months",
    longevity: "12-18 months"
  },
  {
    title: "Medical-Grade Facials",
    description: "Customized facial treatments for skin rejuvenation",
    details: "Professional-grade treatments tailored to your skin type and concerns, incorporating medical-grade products and techniques.",
    icon: Stethoscope,
    duration: "60-90 minutes",
    results: "Immediate glow with progressive improvements",
    longevity: "4-6 weeks"
  }
];

const FacialAesthetics = () => {
  return (
    <div className="min-h-screen bg-gray-50">
      <Navigation />
      <div className="pt-24 px-6 pb-16">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-12">
            <h1 className="text-4xl md:text-5xl font-serif mb-4">Facial Aesthetics</h1>
            <p className="text-lg text-gray-600 max-w-2xl mx-auto">
              Experience the transformative power of our advanced facial aesthetic treatments. Our expert practitioners use the latest techniques and premium products to help you achieve natural-looking results.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-12">
            <img
              src="/lovable-uploads/cd083fce-9885-4549-9e77-519da09b69a9.png"
              alt="Facial Aesthetics"
              className="w-full h-[400px] object-cover rounded-lg shadow-lg"
            />
            <div className="grid grid-cols-2 gap-4">
              <img
                src="/lovable-uploads/ca17819e-1f39-4d01-b880-b18d556f9107.png"
                alt="Treatment 1"
                className="w-full h-[190px] object-cover rounded-lg shadow-lg"
              />
              <img
                src="/lovable-uploads/b1bb3082-ad8c-42b7-8017-5c5f0e6aac30.png"
                alt="Treatment 2"
                className="w-full h-[190px] object-cover rounded-lg shadow-lg"
              />
              <img
                src="/lovable-uploads/f9441e68-79d7-49f3-8086-995384d095da.png"
                alt="Treatment 3"
                className="w-full h-[190px] object-cover rounded-lg shadow-lg"
              />
              <img
                src="/lovable-uploads/24d3003c-8f4f-428f-9d21-2454d7ad7703.png"
                alt="Treatment 4"
                className="w-full h-[190px] object-cover rounded-lg shadow-lg"
              />
            </div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            {treatments.map((treatment) => (
              <Card key={treatment.title} className="hover:shadow-lg transition-shadow">
                <CardHeader>
                  <div className="flex items-center gap-3">
                    <treatment.icon className="w-6 h-6 text-primary" />
                    <CardTitle>{treatment.title}</CardTitle>
                  </div>
                  <CardDescription>{treatment.description}</CardDescription>
                </CardHeader>
                <CardContent>
                  <p className="mb-4 text-gray-600">{treatment.details}</p>
                  <div className="space-y-2 text-sm">
                    <p><span className="font-semibold">Duration:</span> {treatment.duration}</p>
                    <p><span className="font-semibold">Results:</span> {treatment.results}</p>
                    <p><span className="font-semibold">Longevity:</span> {treatment.longevity}</p>
                  </div>
                </CardContent>
              </Card>
            ))}
          </div>

          <div className="mt-12 text-center">
            <a
              href="https://na02.patientnow.com/a/EVOLVEDYOU"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-block bg-primary text-white px-8 py-3 rounded-full text-lg hover:bg-primary/90 transition-colors"
            >
              Schedule a Consultation
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FacialAesthetics;